import { render, staticRenderFns } from "./NavProfileMenuItem.vue?vue&type=template&id=3f04b69e&scoped=true&"
import script from "./NavProfileMenuItem.vue?vue&type=script&lang=ts&"
export * from "./NavProfileMenuItem.vue?vue&type=script&lang=ts&"
import style0 from "./NavProfileMenuItem.vue?vue&type=style&index=0&id=3f04b69e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f04b69e",
  null
  
)

export default component.exports